import { useQuery } from '@tanstack/react-query';
import { getAppointmentTransactions } from '../../services/appointments';
import { Appointment } from '../../interfaces';

function useGetAppointmentPayments(
  appointment: Pick<
    Appointment,
    | 'appointmentId'
    | 'checkoutSessionActive'
    | 'checkoutSessionCompleted'
    | 'paymentStatus'
    | 'depositCheckoutSessionActive'
  > | null,
  { enabled = true } = {},
) {
  const appointmentId = appointment?.appointmentId || '';

  const {
    data = [],
    isPlaceholderData,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: [
      'appointment-payments',
      appointmentId,
      appointment?.checkoutSessionActive,
      appointment?.checkoutSessionCompleted,
      appointment?.paymentStatus,
      appointment?.depositCheckoutSessionActive,
    ],
    queryFn: async () => {
      const result = getAppointmentTransactions(appointmentId);
      return result;
    },
    enabled: !!appointment?.appointmentId && enabled,
    // disable cache - we always want fresh data
    staleTime: 0,
    gcTime: 0,
  });

  return {
    payments: isPlaceholderData ? [] : data,
    isPlaceholderData,
    isLoading,
    isFetching,
    isError,
    error,
  };
}

export default useGetAppointmentPayments;
